import _ from 'lodash'

import { AutomationFieldTypes, LinkTypeLookup } from '@/store/types'

export default {
  methods: {

    formatAutoFieldValue(fieldTypeInfo, value) {
      var outputValue = value

      switch(fieldTypeInfo.fieldType) {
        case AutomationFieldTypes.boolean:
          return parseInt(value || 0) ? 'True' : 'False'

        case AutomationFieldTypes.enum:
        {
          let lookup = fieldTypeInfo.fieldEnumLookup || {}
          if(lookup[value])
            return lookup[value];
        }
        break

        // TODO: Other field types

      }

      return outputValue
    },

    formatComponentObjectLinkTypeName(objectLinkType) {
      var linkType = ('' + objectLinkType).trim()

      // Check if array
      if(linkType.toLowerCase().startsWith('array<')) {
        linkType = linkType.substring(6, linkType.length-1)

        return `List of ${this.formatLookupName(linkType, LinkTypeLookup)}s`
      }

      return this.formatLookupName(linkType, LinkTypeLookup)
    },

    // Check if an input type for a component is linked to a another component's output type
    // The other component must be before the current component
    isComponentInputTypeLinked(ruleComponentList, ruleComponent, inputLinkType, parentAutoRuleComponentId = null, parentOutputTypes = []) {
      if(parentOutputTypes.some(outputTypeInfo => outputTypeInfo.linkType == inputLinkType))
          return true

      for(let listComp of ruleComponentList) {
        if(listComp.parentAutoRuleComponentId != parentAutoRuleComponentId)
          continue

        // Stop once we reach current component
        if(listComp.id == ruleComponent.id)
          break

        if(listComp.autoComponentType && listComp.autoComponentType.outputTypeList) {
          if(listComp.autoComponentType.outputTypeList.some(outputTypeInfo => outputTypeInfo.linkType == inputLinkType))
            return true
        }

        // Check children
        if(this.isComponentInputTypeLinked(ruleComponentList, ruleComponent, inputLinkType, listComp.id, _.concat(parentOutputTypes, listComp.autoComponentType.outputChildTypeList)))
          return true
      }


      return false
    },

    // Build the nested automation component tree info for creating/updating on the server
    prepareComponentListForUpdate(ruleComponentList, parentAutoRuleComponentId = null) {
      var outputList = []

      var listCopy = _.cloneDeep(ruleComponentList)

      // Build sort order for whole list
      if(!parentAutoRuleComponentId) {
        var sortOrder = 0
        listCopy.forEach(listComp => {
          listComp.sortOrder = sortOrder++
        })
      }

      listCopy.filter(listComp => listComp.parentAutoRuleComponentId == parentAutoRuleComponentId).forEach(listComp => {
        let outputComp = _.cloneDeep(listComp)
        outputComp.children = this.prepareComponentListForUpdate(listCopy, outputComp.id)

        // Cleanup info
        if(outputComp.isNewComponent) {
          delete outputComp.id
          delete outputComp.parentAutoRuleComponentId
        }
        delete outputComp.autoComponentType

        outputList.push(outputComp)
      })

      return outputList
    }
  }
}